import { render, staticRenderFns } from "./footer-slider-phone.vue?vue&type=template&id=daf155a2&scoped=true&"
import script from "./footer-slider-phone.vue?vue&type=script&lang=js&"
export * from "./footer-slider-phone.vue?vue&type=script&lang=js&"
import style0 from "./footer-slider-phone.vue?vue&type=style&index=0&id=daf155a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf155a2",
  null
  
)

export default component.exports